import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { store } from "../Store/store";

const useDisableCopyAndDevTools = () => {
  const location = useLocation(); 
  const lastToastRef = useRef(0);
  const userInfo = store.getState();

  useEffect(() => {
    try {
      const persistRoot = localStorage.getItem("persist:root");
      if (!persistRoot) return;

      const parsedRoot = JSON.parse(persistRoot);
      const menuData = JSON.parse(parsedRoot.MenuData || "[]");

      const allMenus = menuData.flatMap((menu) => [
        menu,
        ...(menu.SubMenus || []),
      ]);

      const currentMenu = allMenus.find((m) => m.URL === location.pathname);

      if (!currentMenu || !currentMenu.Is_Copy_Disabled || userInfo.userData.Role_Name === 'Sales-Admin') return;

      const handleContextMenu = (e) => {
        e.preventDefault();
        return false;
      };

      const handleKeyDown = (e) => {
        if (e.ctrlKey && e.key.toLowerCase() === "c") {
          e.preventDefault();
        }

        if(e.ctrlKey && e.key.toLowerCase() === "p"){
          e.preventDefault();
        }

        if (
          e.key === "F12" ||
          (e.ctrlKey && e.shiftKey && ["i", "j"].includes(e.key.toLowerCase())) ||
          (e.ctrlKey && e.key.toLowerCase() === "u")
        ) {
          e.preventDefault();
        }
      };

      document.addEventListener("contextmenu", handleContextMenu);
      document.addEventListener("keydown", handleKeyDown);

      return () => {
        document.removeEventListener("contextmenu", handleContextMenu);
        document.removeEventListener("keydown", handleKeyDown);
      };
    } catch (err) {
      console.error("Error while disabling copy/devtools");
    }
  }, [location.pathname]); 
};

export default useDisableCopyAndDevTools;

